var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.60784 9.9889C4.4173 10.027 4.21017 9.96701 4.07083 9.80989L0.138926 5.36582C-0.0655046 5.13538 -0.0413966 4.78401 0.191962 4.58213C0.426285 4.38026 0.782108 4.40407 0.985573 4.63546L3.93814 7.97113L3.93814 0.555144C3.93814 0.248525 4.18992 -4.20511e-07 4.50062 -3.93349e-07C4.81131 -3.66187e-07 5.06309 0.248525 5.06309 0.555144L5.06308 7.96065L8.0145 4.63451C8.21921 4.40407 8.57455 4.38027 8.8082 4.58309C9.04185 4.78497 9.06529 5.13634 8.86057 5.36678L4.96434 9.75751C4.88228 9.87559 4.75538 9.96033 4.60784 9.9889Z",
    fill: "#FF5050"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.7163240a076b0e34b07298b8d02affee.svg";
export { ForwardRef as ReactComponent };